<template>
    <div :class="[fgClass,{'form-group': isLabelSlot,'has-feedback has-error': validation && validation.$error}]">
        <label v-if="isLabelSlot" :for="id" :class="labelClass">
            <slot name="label"/>
            <template v-if="optional">
                - <small>{{ $t('Optional') }}</small>
            </template>
        </label>
        <div class="mb-1">
            <button v-for="(item, i) of langs"
                    :key="i"
                    type="button"
                    class="btn btn-sm text-uppercase"
                    :class="{ 'btn-primary': item.key === lang }"
                    @click="setLang(item.key)">
                {{ item.key }}
            </button>
        </div>

        <div :class="[inputBlockClass, { 'input-group': isAppendSlot || isPrependSlot }]">
            <div v-if="isPrependSlot" class="input-group-prepend">
                <slot name="input-prepend"/>
            </div>
            <TextEditor
                v-if="useEditor"
                :id="`${lang}-editor`"
                :key="`${lang}-editor`"
                :value="data[lang] || ''"
                :placeholder="placeholder"
                :validation="validation"
                :hide-validation-message="hideValidationMessage"
                :disabled="disabled"
                :allow-image="allowEditorImage"
                @input="setValue"/>
            <textarea
                v-else-if="useTextArea"
                :id="`${lang}-textarea`"
                :value="data[lang]"
                :name="name"
                class="form-control"
                :class="[{'is-invalid': validation && validation.$error,'form-control-lg': isLargeInput}, inputClass]"
                :placeholder="placeholder"
                @input="setValue($event.target.value)"/>
            <input
                v-else
                :id="id"
                :value="data[lang]"
                :name="name"
                class="form-control"
                :class="[{'is-invalid': validation && validation.$error,'form-control-lg': isLargeInput}, inputClass]"
                :type="inputType"
                :disabled="disabled"
                :placeholder="placeholder"
                @input="setValue($event.target.value)"/>
            <div v-if="isAppendSlot" class="input-group-append">
                <slot name="input-append"/>
            </div>
            <ValitationMessages v-if="!hideValidationMessage && !useEditor" :validation="validation"/>
        </div>
    </div>
</template>

<script>
import TextEditor from '@/common/components/tiptap/TextEditor.vue';

export default {
    name: 'EMultiLangInput',
    props: {
        id: [String, Number],
        value: {
            type: Object,
            default: () => ({
                // TYPES
                /*
                [langKey: string]: string;
                */
            })
        },
        type: String,
        langs: {
            type: Array,
            default: () => ([
                // TYPES
                /*
                {
                    key: string;
                }
                */
            ])
        },
        optional: Boolean,
        disabled: Boolean,
        inline: Boolean,
        placeholder: {
            type: String,
            default: ''
        },
        formGroupClass: String,
        large: Boolean,
        inputClass: {
            type: String,
            default: ''
        },
        name: String,
        validation: Object,
        useEditor: {
            type: Boolean,
            default: false
        },
        allowEditorImage: {
            type: Boolean,
            default: false
        },
        useTextArea: {
            type: Boolean,
            default: false
        },
        selectedLang: {
            type: String
        },
        hideValidationMessage: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            lang: this.selectedLang || this.$i18n.locale || 'en'
        };
    },
    computed: {
        data: {
            get() {
                if (this.value && typeof this.value === 'object' && this.value.constructor === Object) {
                    return this.value;
                }

                return {};
            }
        },
        fgClass() {
            return this.formGroupClass;
        },
        isLargeInput() {
            return this.large;
        },
        inputType() {
            if (this.type) {
                return this.type;
            }
            return 'text';
        },
        inputBlockClass() {
            if (this.inline) {
                return 'col-md-7';
            }

            return '';
        },
        labelClass() {
            if (this.inline) {
                return 'col-5 col-md-3';
            }

            return '';
        },
        isLabelSlot() {
            return !!this.$slots.label;
        },
        isAppendSlot() {
            return !!this.$slots['input-append'];
        },
        isPrependSlot() {
            return !!this.$slots['input-prepend'];
        }
    },
    methods: {
        setValue(value) {
            this.$emit('input', {...this.data, [this.lang]: value});
        },
        setLang(lang) {
            this.lang = lang;
        }
    },
    components: {
        TextEditor
    }
};
</script>

<style lang="scss" scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield;
}
</style>
